import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=9e555e2e&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=9e555e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e555e2e",
  null
  
)

export default component.exports